import React from 'react';
import { MdClose, MdLogout, MdWarning } from 'react-icons/md';
import "./LogoutModal.css";

const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay_logoutModal" onClick={onClose}>
      <div className="modal-content_logoutModal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header_logoutModal">
          <div className="modal-icon_logoutModal warning">
            <MdWarning />
          </div>
          {/* <button className="modal-close_logoutModal" onClick={onClose}>
            <MdClose />
          </button> */}
        </div>
        <div className="modal-body_logoutModal">
          <h3>Confirm Logout</h3>
          <p>Are you sure you want to logout? You will need to sign in again to access your account.</p>
        </div>
        <div className="modal-footer_logoutModal">
          <button className="btn-cancel_logoutModal" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-confirm_logoutModal" onClick={onConfirm}>
            <MdLogout />
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;